import { Outlet } from 'react-router';
import { AuthProvider } from '../contexts/AuthContext';
import { CurrencyProvider } from '../contexts/CurrencyContext';
import { BackendStatusBanner } from './BackendStatusBanner';

export function RootLayout() {
  return (
    <AuthProvider>
      <CurrencyProvider>
        <BackendStatusBanner />
        <Outlet />
      </CurrencyProvider>
    </AuthProvider>
  );
}